// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__CpzQA","message":"styles_message__Pk-1F","close":"styles_close__SuFz8"};